import { DELETE_LOCATION_FETCH_REQUEST, DELETE_LOCATION_FETCH_SUCCESS, DELETE_LOCATION_FETCH_FAILURE } from './types';
import baseUrl from '../../url'
import store from '../../../Redux/store';
import { MY_LOCATION_FETCH_SUCCESS } from '../types'

const fetchLocationRequest = () => {
    return {
        type: DELETE_LOCATION_FETCH_REQUEST
    }
}

const fetchLocationSuccess = locations => {
    return {
        type: DELETE_LOCATION_FETCH_SUCCESS,
        payload: locations,
    }
}

const fetchLocationFailure = error => {
    return {
        type: DELETE_LOCATION_FETCH_FAILURE,
        payload: error,
    }
}

export const hideLocation = (address) => {
    return (dispatch) => {
        const token = localStorage.getItem('token');
        dispatch(fetchLocationRequest());
        const locations = store.getState().mylocations
        dispatch({
            type: MY_LOCATION_FETCH_SUCCESS,
            payload: locations.mylocations.filter(m => (m.detail !== address.detail && m.lat !== address.lat && m.long !== address.long))
        })
        fetch(`${baseUrl}/addresses/hide`, {
                method: 'POST',
                body: JSON.stringify({...address }),
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                }
            })
            .then(response => response.json())
            .then((response) => {
                dispatch(fetchLocationSuccess(response))
            })
            .catch((error) => {
                dispatch(fetchLocationFailure(error.message));
            })
    }
}